/**
 * Fetch Custom Checklist Tasks API
 * Feature: 020-thinka-and-create
 */

import axiosInstance from '../axiosInstance';
import { CustomChecklistTaskResponse } from '../createCustomChecklistTask';

export interface FetchCustomChecklistTasksResponse {
  tasks: CustomChecklistTaskResponse[];
  total: number;
}

export const fetchCustomChecklistTasks = async (): Promise<FetchCustomChecklistTasksResponse> => {
  const response = await axiosInstance.get<FetchCustomChecklistTasksResponse>(
    '/api/custom-checklist-tasks'
  );

  return response.data;
};

export const fetchCustomChecklistTask = async (id: string): Promise<CustomChecklistTaskResponse> => {
  const response = await axiosInstance.get<CustomChecklistTaskResponse>(
    `/api/custom-checklist-tasks/${id}`
  );

  return response.data;
};
